const target = ".splide";
const options = {
  type: "loop",
  padding: "0%",
  autoplay: true,
  interval: 5000,
  speed: 1000,
  pauseOnHover: false,
  gap: 0,
  type: "loop",
  rewind: true,
  pagination: true,
  breakpoints: {
    740: {
      padding: "0%",
      arrows: false,
    },
  },
};

const target2 = ".slide_list";
const options2 = {
  type: "loop",
  arrows: false,
  pagination: false,
  drag: false,
  gap: 0,
  perPage: 2,
  padding: "0%",
  autoScroll: {
    speed: 1,
    pauseOnHover: false, 
  },
  breakpoints: {
    740: {
      perPage: 1,
    },
  },
};

document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelector(target)) {
    const mySplide = new Splide(target, options);
    mySplide.mount();
  }
  if (document.querySelector(target2)) {
    const mySplide2 = new Splide(target2, options2);
    mySplide2.mount(window.splide.Extensions);
  }
});

document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    const headerHeight = document.querySelector(".header").offsetHeight;
    const targetId = this.getAttribute("href").substring(1);
    const targetElement = document.getElementById(targetId);
    const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const showButton = document.querySelector(".js-text-show");
  if (showButton) {
    showButton.addEventListener("click", function () {
      const textBody = document.querySelector(".message__text-body");
      textBody.style.height = "auto";
      textBody.style.overflow = "visible";
      document.querySelector(".message__text-btn").style.display = "none";
    });
  }
});

const menuButton = document.getElementById('menuButton');
const menuOverlay = document.getElementById('menuOverlay');

menuButton.addEventListener('click', function() {
  this.classList.toggle('active');
  menuOverlay.classList.toggle('active');
});

function modifyExternalLinks() {
  // 現在のドメインを取得
  const currentDomain = window.location.hostname;

  // すべてのaタグを取得
  const links = document.getElementsByTagName('a');

  // 各リンクをチェック
  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    const href = link.getAttribute('href');

    // hrefが存在し、かつ外部リンクかどうかをチェック
    if (href && !href.startsWith('/') && !href.startsWith('#') && !href.includes(currentDomain)) {
      // 外部リンクの場合、属性を追加
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  }
}

// DOMの読み込みが完了したら関数を実行
document.addEventListener('DOMContentLoaded', modifyExternalLinks);


function offsetAnchor() {
  if (location.hash.length !== 0) {
    window.scrollTo(window.scrollX, window.scrollY - 100); // 100pxはヘッダーの高さに応じて調整
  }
}


// リンククリック時とページロード時に実行
window.addEventListener("hashchange", offsetAnchor);
window.addEventListener("load", offsetAnchor);

document.addEventListener('DOMContentLoaded', function() {
  var resetBtn = document.querySelector('.reset-password-btn');
  var recoverForm = document.getElementById('recover');
  var cancelBtn = recoverForm.querySelector('a[href="#login"]');
  
  resetBtn.addEventListener('click', function(event) {
    event.preventDefault();
    recoverForm.style.display = 'block';
  });

  cancelBtn.addEventListener('click', function(event) {
    event.preventDefault();
    recoverForm.style.display = 'none';
  });
});
